import BaseBlockMap from './BaseBlockMap';
import CreditCardBlockMap from './CreditcardsBlockMap';


export default {
    ...BaseBlockMap,
    ...CreditCardBlockMap,
};
